const skills = [
  'JAVASCRIPT',
  'UML',
  'MYSQL',
  'AJAX',
  'IA',
  'OOP',
  'ECMASCRIPT 6+',
  'DISTRIBUTED COMPUTING',
  'PARALLEL PROCESSING',
  'POSTGRESQL',
  'JAVA',
  'CSS',
  'TASK RUNNERS',
  'RESPONSIVE DESIGN',
  'CSS FRAMEWORKS',
  'JAVASCRIPT FRAMEWORKS',
  'WEB PERFORMANCE',
  'TERMINAL AND SHELL SCRIPT',
  'PHP',
  'SQLSERVER',
  'SQL',
  'JQUERY',
  'HTML5',
  'SVN',
  'XML',
  'NODEJS',
  'MONGODB',
  'C#',
  'GIT',
  'DEV ANDROID',
  'SENCHA JS',
  'SENCHA TOUCH',
  'WORDPRESS',
  'OPENCART',
  'OPENCART',
  'VUE.JS',
  'REACT JS',
  'STYLED COMPONENTS',
  'REDUX',
  'AWS S3',
  'WOOCOMMERCE',
  'BOOTSTRAP',
  'MATERIALIZE CSS',
  'MAC',
  'MVC',
  'PHOTOSHOP',
  'ILLUSTRATOR',
  'GULP',
  'FOUNDATION',
  'LESS',
  'SASS',
  'WINDOWS',
  'LARAVEL',
  'DOCKER',
  'LINUX',
  'NESTJS',
  'ITSCSS',
  'ESLINT',
  'TSLINT',
  'TYPESCRIPT',
  'WEBPACK',
  'BROWSERIFY',
  'PARCEL',
  'RSCSS',
  'BOWER',
  'JEST',
  'ADONISJS',
  'FLEXBOX',
  'GRID LAYOUT',
  'CODEIGNITER',
  'AFTER EFFECTS',
  'PREMIERE',
  'ASP',
  'JSP',
  'SQLITE',
  'JSON',
  'PYTHON',
  'RUBY ON RAILS',
  'UNIX',
  'LATEX',
  'BOWER',
  'PHPMYADMIN',
  'MYSQL WORKBENCH',
  'SQL SERVER',
  'XAMPP',
  'DIGITAL OCEAN',
  'GITLAB',
  'SLIM',
  'TWIG',
  'PDO',
  'COMPOSER',
  'NPM',
  'SEO',
  'DOMPDF',
  'SENDGRID',
  'MANDRILL ADMINLTE',
  'SVG',
  'ANIMATIONS CSS',
  'SUBLIMETEXT',
  'LAMP',
  'ZSH',
  'SLACK',
  'INTEGRATION',
  'NETWORKS',
  'SOCIAL',
  'EMMET',
  'AWS',
  'EC2',
  'TOGGL',
  'VIRTUALBOX',
  'GOOGLE',
  'MAPS',
  'API',
  'LONG',
  'POLLING',
  'DITTO',
  'CAPTCHA',
  'REGEX',
  'SPRITES',
  'FIREBASE',
  'GOOGLE ANALYTICS API',
  'SPOTIFY API',
  'HEROKU',
  'JEKYLL',
]

const iconFooterGithub = '<svg xmlns="http://www.w3.org/2000/svg" width="71.5" height="71.5" viewBox="0 0 71.5 71.5"> <g id="Group_19" data-name="Group 19" transform="translate(-1422 -2861)"> <circle id="bg" data-name="Ellipse 5" cx="35.75" cy="35.75" r="35.75" transform="translate(1422 2861)" fill="#fff"/> <path id="icon" d="M18.683,34.453c-8.122,2.4-8.122-4.061-11.383-4.919m22.766,9.781V33.023a5.584,5.584,0,0,0-1.544-4.233c5.091-.572,10.468-2.517,10.468-11.383a8.751,8.751,0,0,0-2.46-6.12,8.1,8.1,0,0,0-.172-6.12s-1.945-.572-6.349,2.4a21.36,21.36,0,0,0-11.383,0c-4.462-2.974-6.349-2.4-6.349-2.4a8.1,8.1,0,0,0-.172,6.12,8.751,8.751,0,0,0-2.46,6.12c0,8.809,5.377,10.754,10.468,11.383a5.458,5.458,0,0,0-1.544,4.176v6.292" transform="translate(1434.148 2874.753)" fill="none" stroke="#d8473a" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5"/></g></svg>'
const iconFooterTwitter = '<svg xmlns="http://www.w3.org/2000/svg" width="71.5" height="71.5" viewBox="0 0 71.5 71.5"> <g id="Group_20" data-name="Group 20" transform="translate(-1502.652 -2861)"> <circle id="bg" data-name="Ellipse 6" cx="35.75" cy="35.75" r="35.75" transform="translate(1502.652 2861)" fill="#fff"/> <path id="icon" d="M39,12.567a14.688,14.688,0,0,1-4.462,2.174,6.368,6.368,0,0,0-9.038-.629,6.274,6.274,0,0,0-2.174,4.919v1.43A15.278,15.278,0,0,1,10.46,14s-5.72,12.87,7.15,18.59A16.777,16.777,0,0,1,7.6,35.447c12.87,7.15,28.6,0,28.6-16.474a8.533,8.533,0,0,0-.114-1.2A10.483,10.483,0,0,0,39,12.567Z" transform="translate(1514.786 2871.643)" fill="none" stroke="#d8473a" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5"/> </g></svg>'
const iconFooterInstagram = '<svg xmlns="http://www.w3.org/2000/svg" width="71.5" height="71.5" viewBox="0 0 71.5 71.5"> <g id="Group_21" data-name="Group 21" transform="translate(-1583.304 -2861)"> <circle id="bg" data-name="Ellipse 7" cx="35.75" cy="35.75" r="35.75" transform="translate(1583.304 2861)" fill="#fff"/> <g id="icon" transform="translate(1603.324 2881.02)"> <path id="Path_3" class="icon" data-name="Path 3" d="M15.294,7.5h15.73a7.909,7.909,0,0,1,7.894,7.894v15.73a7.909,7.909,0,0,1-7.894,7.894H15.294A7.909,7.909,0,0,1,7.4,31.124V15.336A7.973,7.973,0,0,1,15.294,7.5Z" transform="translate(-7.4 -7.5)" fill="none" stroke="#d8473a" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5"/> <path id="Path_4" class="icon" data-name="Path 4" d="M36.518,29.255a6.3,6.3,0,1,1-7.15-5.32,4.921,4.921,0,0,1,1.83,0A6.31,6.31,0,0,1,36.518,29.255Z" transform="translate(-14.496 -14.498)" fill="none" stroke="#d8473a" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5"/> <line id="Line_53" class="icon" data-name="Line 53" transform="translate(15.787 7.093)" fill="none" stroke="#d8473a" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5"/></g></g></svg>'
const iconFooterFacebook = '<svg xmlns="http://www.w3.org/2000/svg" width="71.5" height="71.5" viewBox="0 0 71.5 71.5"> <g id="Group_22" data-name="Group 22" transform="translate(-1664.528 -2861)"> <circle id="bg" data-name="Ellipse 8" cx="35.75" cy="35.75" r="35.75" transform="translate(1664.528 2861)" fill="#fff"/> <path id="icon" d="M37.174,7.5h-4.69a7.909,7.909,0,0,0-7.894,7.894v4.69H19.9v6.292h4.69V38.96h6.292V26.376h4.69l1.6-6.292H30.882v-4.69a1.6,1.6,0,0,1,1.6-1.6h4.69Z" transform="translate(1671.512 2873.52)" fill="none" stroke="#d8473a" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5"/> </g></svg>'
const iconFooterLinkedIn = '<svg xmlns="http://www.w3.org/2000/svg" width="71.5" height="71.5" viewBox="0 0 71.5 71.5"> <g id="Group_23" data-name="Group 23" transform="translate(-1747.468 -2861)"> <path id="bg" data-name="Path 12" d="M35.75,0A35.75,35.75,0,1,1,0,35.75,35.75,35.75,0,0,1,35.75,0Z" transform="translate(1747.468 2861)" fill="#fff"/> <g id="icon" transform="translate(1767.488 2881.592)"> <path id="Path_6" class="icon" data-name="Path 6" d="M38.938,25.4a9.447,9.447,0,0,1,9.438,9.438V45.82H42.084V34.838a3.146,3.146,0,0,0-6.292,0V45.82H29.5V34.838A9.447,9.447,0,0,1,38.938,25.4Z" transform="translate(-16.916 -15.962)" fill="none" stroke="#d8473a" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.5"/> <path id="Path_11" class="icon" data-name="Path 11" d="M0,0H6.292V18.876H0Z" transform="translate(0 10.982)" fill="none" stroke="#d8473a" stroke-linecap="round" stroke-width="3.5"/> <circle id="Ellipse_3" class="icon" data-name="Ellipse 3" cx="3.146" cy="3.146" r="3.146" transform="translate(0 0)" stroke-width="3.5" stroke="#d8473a" stroke-linecap="round" stroke-linejoin="round" fill="none"/> </g> </g></svg>'

const arrow = '<?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 19 14" version="1.1" viewBox="0 0 19 14" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><style type="text/css">.st0{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}</style><polyline class="st0" points="7.5 12.1 2.5 7.1 7.5 2.1"/><line class="st0" x1="2.5" x2="22" y1="7.1" y2="7.1"/></svg>'

export {
  skills,
  iconFooterGithub,
  iconFooterTwitter,
  iconFooterInstagram,
  iconFooterFacebook,
  iconFooterLinkedIn,
  arrow,
}
